/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable func-names */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-non-null-assertion */
/* eslint-disable no-console */

import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { blockUI, displayMessage, unblockUI } from '../../core_web/store/Application.store';
import ClientFactory from '../api/ApiFactory';

import { PostVeiculoRequest, TipoVeiculosResponseListResult } from '../api/lar.logistica.api';

import { AppDispatch, AppThunk } from './index';

interface VeiculoState {
  CadastroSolicitado: PostVeiculoRequest;
  TiposVeiculo: TipoVeiculosResponseListResult | null;
  cadastroSucesso: boolean;
}

const initialState: VeiculoState = {
  CadastroSolicitado: new PostVeiculoRequest(),
  TiposVeiculo: null,
  cadastroSucesso: false
};

const Veiculo = createSlice({
  name: 'Veiculo',
  initialState,
  reducers: {
    setCadastroSolicitado(state, action: PayloadAction<PostVeiculoRequest>) {
      state.CadastroSolicitado = action.payload;
    },
    setTiposVeiculo(state, action: PayloadAction<TipoVeiculosResponseListResult>) {
      state.TiposVeiculo = action.payload;
    },
    resetData(state) {
      state.CadastroSolicitado = new PostVeiculoRequest();
      state.cadastroSucesso = false;
    },
    setCadastroSucesso(state, action: PayloadAction<boolean>) {
      state.cadastroSucesso = action.payload;
    }
  }
});

export const { setCadastroSucesso, setCadastroSolicitado, setTiposVeiculo, resetData } =
  Veiculo.actions;

export default Veiculo.reducer;

export function clearData(): AppThunk {
  return async function (dispatch: AppDispatch | any | any) {
    dispatch(resetData());
  };
}

export function sendVeiculo(veiculoRequest: PostVeiculoRequest): AppThunk {
  console.log(veiculoRequest);
  return async (dispatch: AppDispatch | any | any) => {
    dispatch(blockUI());
    const client = ClientFactory.GetClient();

    client
      .apiV1VeiculosCadastroVeiculo(veiculoRequest)
      .then(() => {
        dispatch(
          displayMessage({
            message: 'Veiculo cadastrado com sucesso',
            severity: 'success'
          })
        );

        dispatch(setCadastroSucesso(true));
      })
      .catch((err) => {
        dispatch(
          displayMessage({
            message:
              err.message === 'Unauthorized'
                ? 'Não Autorizado, Faça novamente o login'
                : `Não foi possivel cadastrar o veiculo: ${err.message}`,
            severity: 'error'
          })
        );
      })
      .finally(() => dispatch(unblockUI()));
  };
}

export function getTiposVeiculo(): AppThunk {
  return async (dispatch: AppDispatch | any | any) => {
    dispatch(blockUI());
    const client = ClientFactory.GetClient();
    client
      .apiV1VeiculosTiposVeiculos()
      .then((result) => {
        dispatch(setTiposVeiculo(result));
      })
      .catch((err) => {
        dispatch(
          displayMessage({
            message:
              err.message === 'Unauthorized'
                ? 'Não Autorizado, Faça novamente o login'
                : `Erro ao buscar tipos de veículos: ${err.message}`,
            severity: 'error'
          })
        );
      })
      .finally(() => dispatch(unblockUI()));
  };
}
